
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// COMPONENTS
import ProtectedRoute from "./components/ProtectedRoute"; // <-- Import the wrapper
import PublicDocumentViewer from "./components/PublicDocumentViewer"; // <-- New Public Viewer Component

// LEVEL 1 (SUPER ADMIN)
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CreateStore from "./pages/CreateStore";
import Store from "./pages/Store";
import AdminInventory from "./pages/Inventory";
import AdminEmployee from "./pages/Employees";
import AdvanceBilling from "./pages/AdvanceBilling";
import SuperAdminCustomerMatrix from "./pages/CustomerReport";

// LEVEL 2 (STORE MANAGER)
import StoreLogin from "./pages/StoreLogin";
import StoreDashboard from "./pages/StoreDashboard";

// STORE MODULES
import Inventory from "./modules/Inventory";
import Billing from "./modules/Billing";
import Customers from "./modules/Customers";
import Prescriptions from "./modules/Prescriptions";
import Expenses from "./modules/Expenses";
import Employees from "./modules/Employees";
import Reports from "./modules/Reports";
import Settings from "./modules/Settings";
import LandingPage from "./pages/LandingPage";
import AdvancedBillingMatrix from "./pages/AdvanceBilling";
import SuperAdminExpensesMatrix from "./pages/AdminExpense";
import ClosingStock from "./pages/ClosingStock";
import SuperAdminPrescription from "./pages/EyeTesting";
import LoginReport from "./pages/LoginReport";
import ProfitLoss from "./pages/ProfitLoss";
import StoreClosingStock from "./modules/StoreClossingStock";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ===================== */}
        {/* PUBLIC ROUTES         */}
        {/* ===================== */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/store/login" element={<StoreLogin />} />

        {/* NEW: PUBLIC DOCUMENT VIEWER ROUTES (No Login Required) */}
        <Route path="/orderform/:storeId/:orderId" element={<PublicDocumentViewer docType="orderform" />} />
        <Route path="/advance-receipt/:storeId/:orderId" element={<PublicDocumentViewer docType="advance-receipt" />} />
        <Route path="/receipt/:storeId/:orderId" element={<PublicDocumentViewer docType="receipt" />} />
        <Route path="/prescription/:storeId/:orderId" element={<PublicDocumentViewer docType="prescription" />} />


        {/* ===================== */}
        {/* LEVEL 1 - SUPER ADMIN */}
        {/* ===================== */}
        <Route path="/dashboard" element={
          <ProtectedRoute redirectTo="/login">
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/create-store" element={
          <ProtectedRoute redirectTo="/login">
            <CreateStore />
          </ProtectedRoute>
        } />
        <Route path="/stores" element={
          <ProtectedRoute redirectTo="/login">
            <Store />
          </ProtectedRoute>
        } />
        <Route path="/inventory" element={
          <ProtectedRoute redirectTo="/login">
            <AdminInventory />
          </ProtectedRoute>
        } />
        <Route path="/employees" element={
          <ProtectedRoute redirectTo="/login">
            <AdminEmployee />
          </ProtectedRoute>
        } />
        <Route path="/sales" element={
          <ProtectedRoute redirectTo="/login">
            <AdvancedBillingMatrix />
          </ProtectedRoute>
        } />
        <Route path="/expenses" element={
          <ProtectedRoute redirectTo="/login">
            <SuperAdminExpensesMatrix />
          </ProtectedRoute>
        } />
        <Route path="/report/closing-stock" element={
          <ProtectedRoute redirectTo="/login">
            <ClosingStock />
          </ProtectedRoute>
        } />
        <Route path="/eye-testing" element={
          <ProtectedRoute redirectTo="/login">
            <SuperAdminPrescription />
          </ProtectedRoute>
        } />

        <Route path="/customers" element={
          <ProtectedRoute redirectTo="/login">
            <SuperAdminCustomerMatrix />
          </ProtectedRoute>
        } />
        <Route path="/login-report" element={
          <ProtectedRoute redirectTo="/login">
            <LoginReport />
          </ProtectedRoute>
        } />
        <Route path="/billing" element={
          <ProtectedRoute redirectTo="/login">
            <ProfitLoss />
          </ProtectedRoute>
        } />


        {/* ===================== */}
        {/* LEVEL 2 - STORE PANEL */}
        {/* ===================== */}
        {/* Note: Redirecting to /store/login if they aren't authenticated */}
        <Route path="/store/dashboard" element={
          <ProtectedRoute redirectTo="/login">
            <StoreDashboard />
          </ProtectedRoute>
        } />

        <Route path="/store/inventory" element={
          <ProtectedRoute redirectTo="/login">
            <Inventory />
          </ProtectedRoute>
        } />
        <Route path="/store/sales" element={
          <ProtectedRoute redirectTo="/login">
            <Billing />
          </ProtectedRoute>
        } />
        <Route path="/store/customers" element={
          <ProtectedRoute redirectTo="/login">
            <Customers />
          </ProtectedRoute>
        } />
        <Route path="/store/eye-testing" element={
          <ProtectedRoute redirectTo="/login">
            <Prescriptions />
          </ProtectedRoute>
        } />
        <Route path="/store/expenses" element={
          <ProtectedRoute redirectTo="/login">
            <Expenses />
          </ProtectedRoute>
        } />
        {/* <Route path="/store/employees" element={
          <ProtectedRoute redirectTo="/login">
            <Employees />
          </ProtectedRoute>
        } /> */}
        <Route path="/store/reports" element={
          <ProtectedRoute redirectTo="/login">
            <Reports />
          </ProtectedRoute>
        } />
        <Route path="/store/settings" element={
          <ProtectedRoute redirectTo="/login">
            <Settings />
          </ProtectedRoute>
        } />

        <Route path="/store/closing-stock" element={
          <ProtectedRoute redirectTo="/login">
            <StoreClosingStock />
          </ProtectedRoute>
        } />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
